module.exports = __webpack_public_path__ + "img/Capture9.ea3b8dfc.jpg";